import { AcademyRepository } from "../../../domain/repositories/academy.repository";
import { GetCategoryAcademyAllUseCase } from "../../../domain/usecases/academy/get-category-academy-all.usecase";
import { InsertCategoryAcademyUseCase } from "../../../domain/usecases/academy/insert-category-academy.usecase";
import { UpdateCategoryAcademyUseCase } from "../../../domain/usecases/academy/update-category-academy.usecase";
import { GetAllContentAcademyUseCase } from "../../../domain/usecases/academy/get-all-content-academy.usecase";
import { InsertContentAcademyUseCase } from "../../../domain/usecases/academy/insert-content-academy.usecase";
import { UpdateContentAcademyUseCase } from "../../../domain/usecases/academy/update-content-academy.usecase";
import { InsertContentResourceUseCase } from "../../../domain/usecases/academy/insert-content-resource.usecase";
import { UpdateContentResourceUseCase } from "../../../domain/usecases/academy/update-content-resource.usecase";
import { GetContentResourceByIdUseCase } from "../../../domain/usecases/academy/get-content-resource-by-id.usecase";
import { GetContentAcademyByIdUseCase } from "../../../domain/usecases/academy/get-content-academy-by-id.usecase";
import { GetAllTypeResourceUseCase } from "../../../domain/usecases/academy/get-all-type-resource.usecase";
import { InsertTypeResourceUseCase } from "../../../domain/usecases/academy/insert-type-resource.usecase";
import { UpdatetyperesourceUseCase } from "../../../domain/usecases/academy/update-type-resource.usecase";
import { GetalltypemimeUseCase } from "../../../domain/usecases/academy/get-all-type-mime.usecase";
import { InsertTypeMimeUseCase } from "../../../domain/usecases/academy/insert-type-mime.usecase";
import { UpdateTypeMimeUseCase } from "../../../domain/usecases/academy/update-type-mime.usecase";


const getcategoryacademyallUseCaseFactory =
(ClientRepo: AcademyRepository) =>
new GetCategoryAcademyAllUseCase(ClientRepo);

export const GetCategoryAcademyAllUseCaseProvider = {
    provide:
    GetCategoryAcademyAllUseCase,
    useFactory:
    getcategoryacademyallUseCaseFactory,
    deps: [
        AcademyRepository
    ],
};

const insertcategoryacademyUseCaseFactory =
(ClientRepo: AcademyRepository) =>
new InsertCategoryAcademyUseCase(
    ClientRepo
);

export const InsertCategoryAcademyUseCaseProvider = {
    provide:
    InsertCategoryAcademyUseCase,
    useFactory:
    insertcategoryacademyUseCaseFactory,
    deps: [
        AcademyRepository
    ],
};

const updatecategoryacademyUseCaseFactory =
(ClientRepo: AcademyRepository) =>
new UpdateCategoryAcademyUseCase(
    ClientRepo
);

export const UpdateCategoryAcademyUseCaseProvider = {
    provide:
    UpdateCategoryAcademyUseCase,
    useFactory:
    updatecategoryacademyUseCaseFactory,
    deps: [
        AcademyRepository
    ],
};

const getAllContentAcademyUseCaseFactory =
(ClientRepo: AcademyRepository) =>
new GetAllContentAcademyUseCase(
    ClientRepo
);

export const GetAllContentAcademyUseCaseProvider = {
    provide:
    GetAllContentAcademyUseCase,
    useFactory:
    getAllContentAcademyUseCaseFactory,
    deps: [
        AcademyRepository
    ],
};

const insertcontentacademyUseCaseFactory =
(ClientRepo: AcademyRepository) =>
new InsertContentAcademyUseCase(
    ClientRepo
);

export const
InsertContentAcademyUseCaseProvider = {
    provide:
    InsertContentAcademyUseCase,
    useFactory:
    insertcontentacademyUseCaseFactory,
    deps: [
        AcademyRepository
    ],
};


const updatecontentacademyUseCaseFactory =
(ClientRepo: AcademyRepository) =>
new UpdateContentAcademyUseCase(
    ClientRepo
);

export const
UpdateContentAcademyUseCaseProvider = {
    provide:
    UpdateContentAcademyUseCase,
    useFactory:
    updatecontentacademyUseCaseFactory,
    deps: [
        AcademyRepository
    ],
};


const getContentAcademyByIdUseCaseFactory =
(ClientRepo: AcademyRepository) =>
new GetContentAcademyByIdUseCase(
    ClientRepo
);

export const
GetContentAcademyByIdUseCaseProvider = {
    provide:
    GetContentAcademyByIdUseCase,
    useFactory:
    getContentAcademyByIdUseCaseFactory,
    deps: [
        AcademyRepository
    ],
};

const insertcontentresourceUseCaseFactory =
(ClientRepo: AcademyRepository) =>
new InsertContentResourceUseCase(
    ClientRepo
);

export const
InsertContentResourceUseCaseProvider = {
    provide:
    InsertContentResourceUseCase,
    useFactory:
    insertcontentresourceUseCaseFactory,
    deps: [
        AcademyRepository
    ],
};

const updatecontentresourseUseCaseFactory =
(ClientRepo: AcademyRepository) =>
new UpdateContentResourceUseCase(
    ClientRepo
);

export const
UpdateContentResourseUseCaseProvider = {
    provide:
    UpdateContentResourceUseCase,
    useFactory:
    updatecontentresourseUseCaseFactory,
    deps: [
        AcademyRepository
    ],
};



const getcontentresourcebyidUseCaseFactory =
(ClientRepo: AcademyRepository) =>
new GetContentResourceByIdUseCase(
    ClientRepo
);

export const
GetContentResourceByIdUseCaseProvider = {
    provide:
    GetContentResourceByIdUseCase,
    useFactory:
    getcontentresourcebyidUseCaseFactory,
    deps: [
        AcademyRepository
    ],
};


const getAllTypeResourceUseCaseFactory =
(ClientRepo: AcademyRepository) =>
new GetAllTypeResourceUseCase(
    ClientRepo
);

export const
GetAllTypeResourceUseCaseProvider = {
    provide:
    GetAllTypeResourceUseCase,
    useFactory:
    getAllTypeResourceUseCaseFactory,
    deps: [
        AcademyRepository
    ],
};

const inserttyperesourceUseCaseFactory =
(ClientRepo: AcademyRepository) =>
new InsertTypeResourceUseCase(
    ClientRepo
);

export const
InsertTypeResourceUseCaseProvider = {
    provide:
    InsertTypeResourceUseCase,
    useFactory:
    inserttyperesourceUseCaseFactory,
    deps: [
        AcademyRepository
    ],
};


const updatetyperesourceUseCaseFactory =
(ClientRepo: AcademyRepository) =>
new UpdatetyperesourceUseCase(
    ClientRepo
);

export const
UpdatetyperesourceUseCaseProvider = {
    provide:
    UpdatetyperesourceUseCase,
    useFactory:
    updatetyperesourceUseCaseFactory,
    deps: [
        AcademyRepository
    ],
};

const getalltypemimeUseCaseFactory =
(ClientRepo: AcademyRepository) =>
new GetalltypemimeUseCase(
    ClientRepo
);

export const
GetalltypemimeUseCaseProvider = {
    provide:
    GetalltypemimeUseCase,
    useFactory:
    getalltypemimeUseCaseFactory,
    deps: [
        AcademyRepository
    ],
};

const inserttypemimeUseCaseFactory =
(ClientRepo: AcademyRepository) =>
new InsertTypeMimeUseCase(
    ClientRepo
);

export const
InsertTypeMimeUseCaseProvider = {
    provide:
    InsertTypeMimeUseCase,
    useFactory:
    inserttypemimeUseCaseFactory,
    deps: [
        AcademyRepository
    ],
};


const updatetypemimeUseCaseFactory =
(ClientRepo: AcademyRepository) =>
new UpdateTypeMimeUseCase(
    ClientRepo
);

export const
UpdateTypeMimeUseCaseProvider = {
    provide:
    UpdateTypeMimeUseCase,
    useFactory:
    updatetypemimeUseCaseFactory,
    deps: [
        AcademyRepository
    ],
};
